import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.sass']
})
export class NotFoundComponent implements OnInit {

  constructor(private router: Router, private langService: LanguageService) { }

  langObs: any;
  language: string;

  ngOnInit() {
    this.langObs = this.langService.languageObs();
    this.langObs.subscribe((lang: string) => {
      this.language = lang;
    });
  }

  goToMain() {
    this.router.navigate(['']); // temporary
  }

}
